/**
 *
 * Resize
 *
 */

import React, { useMemo } from 'react';
import { isBot } from 'utils/stringUtils';
import qs from 'qs';

const withResize = WrappedComponent => props => {
  const params = useMemo(() => qs.parse(window.location.search.slice(1)), [
    window.location.search,
  ]);
  const bot = isBot();
  const forceMobile = bot && params.mobile === 'true';

  return <WrappedComponent forceMobile={forceMobile} {...props} />;
};

export default withResize;
